<script lang="ts">
  import { goto } from '$app/navigation';
  import Seed from '$icons/SeedIcon.svelte';
  import type { TopDonorsItem } from '$src/utils/api/topDonors.util';

  export let item: TopDonorsItem;
</script>

<button on:click={() => {
        goto(`/profile/${item.userName}`)
    }}
    class="group text-left w-full flex px-4 items-center">
	<div class="relative">
		<div class="rounded-full w-10 aspect-square overflow-hidden bg-gray-100">
			{#if item.profileImage}
				<img src={item.profileImage} alt="" />
			{:else}
				<img
					src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${item.userName}`}
					alt=""
				/>
			{/if}
		</div>

    <div class="absolute -right-4 -bottom-3 p-[3px] rounded-full bg-white grid place-items-center">
      <div
        class="bg-blueish-grey-300 text-blueish-grey-900 rounded-full h-6 min-w-[1.5rem] text-center font-semibold px-1"
      >
        {item.position}
      </div>
    </div>
  </div>

	<div class="group-hover:underline text-sm text-accent-blue-80 flex-grow ml-6">{item.userName}</div>

	<div class="flex gap-x-2 text-blueish-grey-600 text-sm">
		<Seed />
		<div>{item.timeWindowDonatedSeed}</div>
	</div>
</button>
